import React from "react";
export const CityNameColumnFormatter = (cellContent, row, rowIndex) => {
  const { name = "-" } = row || {};
  return (
    <>
      <div className="d-flex align-items-center text-capitalize">
        {`${name}`}
      </div>
    </>
  );
};
